import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=cef61784&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew_reset.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/renew2_style.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/renew2_login.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports